import { getApiUrl } from "../services/apiConfig";
import { PROFILE_AVATARS } from "../components/ProfileSummary/index.jsx";
export const sourceImage = (path) => {
  if (!path) return null;
  if (typeof path !== "string") return path;
  if (
    /^\/static\/avatars\/[a-z]+\.svg$/.test(path) &&
    PROFILE_AVATARS.some((item) => item.path === path)
  )
    return window.location.origin + path;
  if (path.startsWith("data:")) return path;
  if (/^https?:\/\//i.test(path)) return path;
  return getApiUrl(path);
};
